module.exports = "/static-assets/_next/static/images/shopping-divider-ea170c51fb782998cd20cbfbc2492025.svg";